export default __webpack_public_path__ + "img/b43efaaa2fefec35bb29e9afdb81a01a.svg";